var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.036 1.01C14.842.42 14.313 0 13.694 0H3.306c-.62 0-1.148.42-1.342 1.01L0 7v8c0 .55.425 1 .944 1h.945c.524 0 .944-.45.944-1v-1h11.334v1c0 .55.425 1 .944 1h.945c.524 0 .944-.45.944-1V7l-1.964-5.99zM3.306 11c-.784 0-1.417-.67-1.417-1.5S2.522 8 3.306 8c.783 0 1.416.67 1.416 1.5S4.09 11 3.306 11zm10.388 0c-.783 0-1.416-.67-1.416-1.5S12.91 8 13.694 8c.784 0 1.417.67 1.417 1.5s-.633 1.5-1.417 1.5zM1.89 6l1.417-4.5h10.388L15.111 6H1.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.b0e94be9c5de1f80c78f9a22cfb05019.svg";
export { ForwardRef as ReactComponent };